/* eslint-disable comma-dangle */
/* eslint-disable react/require-default-props */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { CategoryState } from '../../store/ducks/category/types';
import { LocalclassificationState } from '../../store/ducks/localClassification/types';
import { Label, styles } from './styles';

interface Props {
  label?: string;
  data: Array<CategoryState | LocalclassificationState | any>;
  onchangeObject: any;
  values: any;
  required?: boolean;
}

const SelectCustom: React.FC<Props> = ({
  data,
  onchangeObject,
  values,
  label,
  required,
}) => {
  const handleChange = (event: any) => {
    onchangeObject(
      data?.filter((item) => item.codigo === event.target.value)[0]
    );
  };
  return (
    <FormControl fullWidth>
      <Label id="demo-simple-select-label">{label}</Label>
      <Select
        value={values}
        fullWidth
        required={required ?? false}
        defaultValue={values}
        style={styles.select}
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        onChange={handleChange}
      >
        {data?.map((item: CategoryState | LocalclassificationState) => (
          <MenuItem key={item.codigo} value={item.codigo}>
            {item.nome}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export default SelectCustom;
